import * as React from "react";
import { Field, FieldSet } from "../modelDialogs/BaseDialog";
import { ChannelType, channelTypeFromString, channelTypeInfo, DeviceType } from "../models/ChannelType";
import Device from "../models/Device";
import DeviceProductDetails from "./DeviceProductDetails";
import { useOnChangeWatcher } from "../models/useOnChangeWatcher";
import { useEffect, useState, useRef } from "react";

import Logger from "../Logger";
import { showToast } from "./Toasts";
import Actor from "../models/Actor";

import DeviceReference from "../models/DeviceReference";
import { isUiModeDeveloper, isUiModeProductAdmin } from "../uiMode";
import ProblemWithProductDialog from "./dialogs/ProblemWithProductDialog";
import FullPhysicalAddressView from "../modelViews/FullPhysicalAddressView";

import { itx, noItx } from "../translationItx/itx";
import { isDevelopmentEnvironment } from "../estada-config-release";
import { useRedraw } from "../models/useRerender";
import ConnectableObject from "src/models/ConnectableObject";

import { TemplateSelection } from "./TemplateSelection";


const logger = new Logger();
export function RequestProductBlock() {
  return (
    <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center" }}>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "center",
          width: "max-content",
          padding: "10px",
          borderRadius: "5px",
          gap: "10px",
          marginTop: "20px",
          backgroundColor: "#f1f1f1",
        }}
      >
        <div>
          <img style={{ height: "30px", width: "auto" }} src={state.hostBaseUrl + "images/warning.png"}></img>
        </div>
        <div>{itx("ServerTemplateList.productNotFound", "Findest Du ein Produkt nicht?")}</div>
        <button
          className="button"
          onClick={() => {
            window.location.href = "mailto:Info@Estada.de?subject=fehlendes%20KNX%20Produkt"; // no itx
          }}
        >
          {itx("ServerTemplateList.productNotFoundButton", "Produkt anfragen")}{" "}
        </button>
      </div>
    </div>
  );
}
export function RequestProductBlock2() {
  return (
    <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center" }}>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "center",
          width: "max-content",
          padding: "10px",
          borderRadius: "5px",
          gap: "10px",
          marginTop: "20px",
          backgroundColor: "#f1f1f1",
        }}
      >
        <div>
          <img style={{ height: "30px", width: "auto" }} src={state.hostBaseUrl + "images/warning.png"}></img>
        </div>
        <div>{itx("ServerTemplateList.productNotFound", "Findest Du ein Produkt nicht?")}</div>
        <button
          className="button"
          onClick={() => {
            state.dialogManager.openDialog(<ProblemWithProductDialog productData={undefined} />);
          }}
        >
          {itx("ServerTemplateList.productNotFoundButton", "Produkt anfragen")}{" "}
        </button>
      </div>
    </div>
  );
}

export function SetSameTemplateSettingsButton(props: { device: Device }) {
  const { device } = props;
  const [deviceCopied, setDeviceCopied] = useState(false);
  const template = device.template;
  const templateUsags = new Array<any>();
  // function handleTempSettingAdapt() {
  //   template?.treeViewModel.childCollection?.forEach((child) => {
  //     const referenceDevice = child as BaseModelReference;
  //     const otherDevice = referenceDevice.referencedObject as Device;
  //     if (otherDevice != device) {
  //       //// set here the same settings of template
  //     }
  //   });
  //   //if done
  //   showToast({
  //     text: state.translate("menubarActions.templateSettingsAdapted", "template settings adopted"),
  //   });
  // }
  function TemplateUsageElement(props: { deviceReference: DeviceReference }) {
    const { deviceReference } = props;
    return (
      <div
        onClick={() => (state.selectionManager.selectedObject = deviceReference.referencedObject)}
        key={deviceReference.id}
        style={{
          cursor: "pointer",
          paddingLeft: "10px",
          color: "var(--textColorGray)",
        }}
      >
        {deviceReference.tag} {deviceReference.getName()}
      </div>
    );
  }
  if (template) {
    const childCollection = template.treeViewModel.childCollection;
    childCollection?.forEach((child) => {
      const deviceReference = child as DeviceReference;
      if (deviceReference.referencedObject != device) {
        templateUsags.push(<TemplateUsageElement deviceReference={deviceReference} />);
      }
    });
  }
  if (templateUsags.length > 0) {
    const classNameCopied = state.clipboard.getClassName();
    if ((classNameCopied == "Actor" || classNameCopied == "Button") && deviceCopied == false) {
      setDeviceCopied(true);
    } else if (classNameCopied != "Actor" && classNameCopied != "Button" && deviceCopied == true) {
      setDeviceCopied(false);
    }

    return (
      <div>
        <div style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: "8px", flexWrap: "wrap" }}>
          <span>{state.translate("deviceTemplatePropertieView.AllParameters", "Alle Parameter")}:</span>
          <button
            className="button"
            onClick={(ev) => {
              state.menubarActions.onCopy(device);
              showToast({
                text: state.translate("tabGeneralDevice.templateCopied", "Tamplate is copied"),
              });
            }}
          >
            {state.translate("ContextMenuLables.copy", "copy ")}
          </button>
          <button
            className="button"
            disabled={!deviceCopied}
            onClick={(ev) => {
              state.menubarActions.pastePropertiesTemplate(device);
            }}
          >
            {state.translate("ContextMenuLables.paste", "paste")}
          </button>
        </div>

        <div style={{ fontSize: "12px" }}>
          {state.translate("tabGeneralDevice.theseT1areUsingTheSameTemplate", `these T1 are using the same Template:`, {
            T1: state.translate("components.plural." + device.className, device.className),
          })}
        </div>
        <div style={{ fontSize: "12px" }}>{templateUsags}</div>
      </div>
    );
  }
  return <div style={{ display: "none" }}></div>;
}

export default function TabGeneralDevice(props: { device: Device }) {
  const { device } = props;

  const redraw = useRedraw();

  useOnChangeWatcher(device, (changedProperty) => {
    if (changedProperty == "template") {
      updateFrontImage();
    }
    return true;
  });

  useOnChangeWatcher(device.template, () => {
    void updateFrontImage();
    return true;
  });
  useOnChangeWatcher(device.channels);
  logger.log("TabGeneralDevice");

  const [modalOpen, setModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState("");
  const [caption, setCaption] = useState("");
  const [loadedFrontImage, setFrontImage] = useState<string | undefined>();
  const frontImage = device.template?.useGenericImage || device.template?.isGeneric
    ? device.frontImage : loadedFrontImage;
  const [frontImageSource, setFrontImageSource] = useState("");

  const tagIsSetManual = useRef<boolean>(false);
  const nameInputRef = useRef<HTMLInputElement>(null);
  const tagInputRef = useRef<HTMLInputElement>(null);
  const devIsSupply = channelTypeInfo(device.channelType).isSupply;

  //const [scrollHeight, setScrollHeight] = useState<number>(0);

  const openModal = (device: any) => {
    const productFrontImage = device.frontImage;
    logger.log(device);
    const altText = device.template?.displayName;
    setSelectedImage(productFrontImage);
    setCaption(altText);
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
  };
  useEffect(() => {
    updateFrontImage();
    setTimeout(() => {
      if (nameInputRef.current) {
        nameInputRef.current?.focus();
      }
    }, 100);
  }, []);

  async function updateFrontImage() {
    // 1st Check if Our Catalog has ImageBlobs available.
    // 2nd if not existing, check inside variants if exists.
    // Else set undefined
    // const imgFromEstadaCatalog = await device.template?.knxProductData.loadFrontImage();
    // if (imgFromEstadaCatalog) {
    //   setFrontImage(device.frontImage);
    // } else {
    //   const imgURLFromVariant = device.template?.orderInformation?.imageLink;
    //   if (imgURLFromVariant) {
    //     setFrontImage(imgURLFromVariant);
    //   } else {
    //     setFrontImage(undefined);
    //   }
    // }

    if (!device.template?.useGenericImage && device.template?.knxProductData.frontImageLoaded == false) {
      await device.template?.knxProductData.loadFrontImage();
    }

    if (device?.frontImage) {
      setFrontImage(device.frontImage);
      setFrontImageSource(device.template?.useGenericImage || device.template?.isGeneric ? "" : device.template?.knxProductData.frontImageSourceDescription || "");
      return;
    } else {
      setFrontImage(undefined);
      setFrontImageSource("");
    }
  }

  function changeChannelNumber(newNumber: number) {
    device.modifyChannelNumber(newNumber);
  }

  const actorTypesSelectionElmements: any = [];
  if (device.isActor && !devIsSupply) {
    actorTypesSelectionElmements.push(
      <option
        value={ChannelType.Unknown}
        key={"channeltype" + ChannelType.Unknown} // no itx
      >
        {state.translate("tabGeneralDevice.automaticCreation", "automatisch definiert")}
      </option>,
    ); // only from bevore -> only relevant for Actor
  }
  let selectableDeviceType = [
    DeviceType.Switch,
    DeviceType.Dimmer,
    DeviceType.TuneableWhite,
    DeviceType.Heating,
    DeviceType.Jalousie,
    DeviceType.Blind,
    DeviceType.Lock,
    DeviceType.Input,
    DeviceType.Lan,
  ];

  if (devIsSupply) {
    selectableDeviceType = [DeviceType.suply12V, DeviceType.suply230V, DeviceType.suply24V, DeviceType.suply400V];
  }

  //for (let i in ChannelType) {
  //  const channelType = i;
  selectableDeviceType.forEach((deviceType) => {
    let optionText = state.translate(`channelType.${deviceType}`, deviceType);
    if (isUiModeProductAdmin() && device.template) {
      if (device.template.knxProductData.productInfo.ChannelType == deviceType) {
        optionText = optionText + itx("TabGeneralDevice.product", " (Produkt)");
      }
    }

    actorTypesSelectionElmements.push(
      <option
        value={deviceType}
        key={"channeltype" + deviceType} // no itx
      >
        {optionText}
      </option>,
    );
  });

  let disableTypeSelection = false;

  if (device.template && !isUiModeProductAdmin()) {
    disableTypeSelection = true;
  }

  function onBlurTag(ev: any) {
    try {
      const lastValue = device.tag;

      let value: any = ev.target.value.trim();

      if (value == lastValue) {
        return;
      }

      let setValue = true;
      let showWarning: string = "";
      ////////////////////////////
      // tag
      ///////////////////////////
      // empty value as tag forbidden exept for cabinet
      if (value == "") {
        setValue = false;
        showWarning = "emptyTag"; // no itx
      }

      // check if double tag
      if (setValue) {
        // set value to max characters
        if (value.length > device.maxTagCharacters) {
          value = value.substring(0, device.maxTagCharacters);
        }
        // check if tag exists
        const allTagsWithoutOwn = device.getAllTagsFromSameTypeWithoutOwn() || [];
        if (allTagsWithoutOwn.includes(value)) {
          showWarning = "doubleTag"; // no itx
          value = state.nameAndTagManager.getAvailableTagWithBracetsIfNeeded(value, allTagsWithoutOwn);
        }
        // check if din norm chars are in tag
        const valueWithoutForbiddenDinValues = value
          .replace("=", "")
          .replace("-", "")
          .replace("+", "")
          .replace(".", "");

        if (valueWithoutForbiddenDinValues != value) {
          value = valueWithoutForbiddenDinValues;
          showWarning = "forbiddenDinChars";
        }
      }

      if (showWarning != "" && showToast) {
        let text = showWarning;
        switch (showWarning) {
          case "emptyTag":
            text = state.translate("handleTagEdit.emptyForbidden", "leer nicht erlaubt");
            break;
          case "doubleTag":
            text = state.translate("handleTagEdit.T1AlreadyPresent", "eingegebener Text existiert schon", {
              T1: ev.target.value.trim(),
            });
            break;
          case "forbiddenDinChars":
            text = state.translate(
              "handleTagEdit.forbiddenDinChars",
              "Der Tag darf keine der folgenden Zeichen enthalten: = - + .",
            );
            break;
          case "double":
            text = state.translate("handleTagEdit.double", "Der eingegebene Text existiert bereits.");
            break;
          case "notInRange":
            text = state.translate("handleTagEdit.numberToHigh", "die Zahl T1 ist nicht im zugewiesenen wertebereich");
            break;
        }
        showToast({ text: text });
      }
      if (device && setValue) {
        // to upper case

        value = value.toUpperCase();
        // setValue
        device.tag = value;
        ev.target.innerText = value;
        device.raiseOnChange("tag");
        ev.target.value = device.tag;
      }

      (window as any).getSelection()?.removeAllRanges();
    } catch (ex) {
      logger.error(ex);
    }
  }

  function channelCount(): number {
    // show only channels which can be connectet to consumer/ or allready connected
    let res = 0;
    for (const child of device.treeViewModel.childCollection || []) {
      if (channelTypeInfo((child as ConnectableObject)?.channelType)?.canBeConnectedWithPartner) {
        res++;
      }
    }
    return res;
  }

  function onClickProblemButton(event: any): void {
    // here send the Product information
    state.dialogManager.openDialog(<ProblemWithProductDialog productData={device.template?.knxProductData} />);
  }
  // because of undo only shown in developer mode

  // if (isSupply) {
  //   disableTypeSelection = true;
  //   actorTypesSelectionElmements = [
  //     <option
  //       value={device.channelType}
  //       key={"channelType" + device.channelType} // no itx
  //     >
  //       {state.translate(`channelType.${device.channelType}`, device.channelType)}
  //     </option>,
  //   ];
  // }

  return (
    <div
      className="tabGeneral"
      id="tabGeneral"
      style={{
        padding: "5px 20px",
        display: "flex",
        flexFlow: "wrap",
        backgroundColor: "white",
      }}
    >
      <style>
        {`
        #tabGeneral table td,
        #tabGeneral table th {
          padding-left: 0px;
        }
      `}
      </style>
      <div
        id="leftColumn"
        key="leftColumn"
        style={{
          position: "relative",
          width: "32vw",
          minWidth: "200px",
        }}
      >
        <div
          style={{
            marginTop: "10px",
            backgroundColor: "var(--backgroundColorGrey)",
            color: "var(--white1)",
            padding: "5px",
          }}
        >
          &nbsp;
          {devIsSupply
            ? state.translate("tabGeneralDevice.supply", "Spannungsversorgung")
            : state.translate("tabGeneralDevice.deviceData", "Gerätedaten")}
        </div>

        <FieldSet key="tag">
          {!devIsSupply && (
            <Field label={state.translate("tag", "Tag")}>
              <input
                key={"tag" + device.tag}
                defaultValue={device.tag}
                id="TabGeneralDevice_Tag"
                ref={tagInputRef}
                className="input"
                maxLength={device.maxTagCharacters}
                onBlur={(ev) => {
                  onBlurTag(ev);
                }}
                onChange={(ev) => {
                  if (state.settings.tagNameAlwaysUpperCase) {
                    if (ev.target.innerText.replace(/[^a-zA-Z0-9]/g, "") != ev.target.value) {
                      ev.target.value = ev.target.value.replace(/[^a-zA-Z0-9]/g, "");
                    }

                    ev.target.value = ev.target.value.toUpperCase().trim();
                  }
                  tagIsSetManual.current = true;
                }}
              ></input>
            </Field>
          )}

          <Field label={state.translate("name", "Name")} key="label">
            <input
              key={"name" + device.displayName} // no itx
              className="input"
              id="TabGeneralDevice_Tag"
              maxLength={device.maxNameCharacters}
              defaultValue={device.displayName}
              onBlur={(ev) => {
                device.displayName = ev.target.value;
                device.raiseOnChange("name");
              }}
              onInput={(ev) => {}}
            ></input>
          </Field>

          {isUiModeProductAdmin() && device.template?.knxProductData?.productInfo && (
            <Field label={itx("productWizard.productType", "Product type")} key="productType">
              <input
                className="input"
                disabled={true}
                maxLength={state.maxCharLimit.smallText}
                value={device.template.knxProductData.productInfo.ProductType || "-"}
                readOnly
              />
            </Field>
          )}

          {device.isActor && (
            <Field label={itx("productWizard.channelType", "Channel type")} key="type">
              <div style={{ display: "flex", flexDirection: "row", flexGrow: 1, gap: "5px", alignItems: "center" }}>
                <select
                  className="select"
                  key={device.channelType}
                  id="TabGeneralDevice_ChannelType"
                  defaultValue={device.channelType}
                  onChange={(ev) => {
                    const deviceTemplate = device.template;
                    if (deviceTemplate) {
                      deviceTemplate.knxProductData.productInfo.ChannelType = ev.target.value as ChannelType;
                    }
                    const changeName = device.displayName == itx("channelType." + device.channelType);
                    if (changeName) {
                      const newChannelType = channelTypeFromString(ev.target.value);
                      device.channelType = newChannelType;
                      if (newChannelType == ChannelType.suply230V || newChannelType == ChannelType.suply400V) {
                        device.template = undefined;
                        device.raiseOnChange("template");
                      }
                      device.raiseOnChange("channelType");
                      device.modifyChannelNumber(device.channels.size);
                      // change Name if supply
                      if (devIsSupply && changeName) {
                        const newName = itx("channelType." + newChannelType);
                        device.displayName = newName;
                      }
                    }
                    redraw();
                  }}
                  disabled={disableTypeSelection}
                >
                  {actorTypesSelectionElmements}
                </select>
                <input
                  type="checkbox"
                  style={{ width: "20px", marginLeft: "10px", marginRight: "0px" }}
                  className="checkbox"
                  checked={device.isDali}
                  disabled={device.template != undefined} // only changeable if no template is set, because Dali is a relevant information for the template
                  onChange={(ev) => {
                    device.isDali = ev.target.checked;
                    redraw();
                    // update connections
                    device.channels.forEach((channel) => {
                      channel.connections.forEach((connection) => {
                        connection.checkForbidden();
                        connection.raiseOnChange("isDali");
                      });
                    });
                  }}
                />
                <div> {itx("TabGeneral.isDali", "ist Dali")}</div>
              </div>
            </Field>
          )}
          {device.isDecentralActor && (
            <Field label={itx("TabGeneral.isDali", "ist Dali")} key="type">
              <div style={{ display: "flex", flexDirection: "row", flexGrow: 1, gap: "5px", alignItems: "center" }}>
                <input
                  type="checkbox"
                  style={{ width: "20px", marginLeft: "10px", marginRight: "0px" }}
                  className="checkbox"
                  checked={device.isDali}
                  disabled={device.template != undefined} // only changeable if no template is set, because Dali is a relevant information for the template
                  onChange={(ev) => {
                    device.isDali = ev.target.checked;
                    redraw();
                    // update connections
                    device.channels.forEach((channel) => {
                      channel.connections.forEach((connection) => {
                        connection.checkForbidden();
                        connection.raiseOnChange("isDali");
                      });
                    });
                  }}
                />
                <div> {itx("TabGeneral.isDali", "ist Dali")}</div>
              </div>
            </Field>
          )}
          {device.isActor && device.channelType != ChannelType.Unknown && !devIsSupply && (
            <Field label={state.translate("components.plural.Channel", "Kanäle")} key="channelCount">
              <div
                key={"number" + channelCount()} // no itx
                style={{
                  textAlign: "center",
                  justifyContent: "space-between",
                  display: "flex",
                  alignItems: "center",
                  border: "1px solid var(--border-color)",
                  borderRadius: "var(--input-border-radius)",
                  height: "var(--input-height)",
                }}
              >
                {/* {!device.template && (
                    <i
                      className="las la-angle-left"
                      onClick={() => {
                        if (channelCount() >= 2 && device.template == undefined) {
                          (device as Actor).numberChannelsFromUser = channelCount() - 1;
                          changeChannelNumber(channelCount() - 1);
                        }
                      }}
                    ></i>
                  )} */}

                <input
                  className="input inputPageNumber"
                  style={{
                    textAlign: "center",
                    width: "60px",
                    height: "25px",
                    border: "none",
                  }}
                  type="number" // no itx
                  id="TabGeneralDevice_ChannelCount"
                  min={1}
                  max={32}
                  defaultValue={channelCount()}
                  onBlur={(ev) => {
                    if (parseInt(ev.target.value) >= 1 && parseInt(ev.target.value) <= 32) {
                      changeChannelNumber(parseInt(ev.target.value));
                      (device as Actor).numberChannelsFromUser = parseInt(ev.target.value);
                    } else {
                      ev.target.value = channelCount().toString();
                      showToast({
                        text: state.translate(
                          "tabGeneralDevice.numberNotInArea",
                          "ihre eingegebene Zahl ist nicht in der zugelassenen Bereich von 1-32",
                        ),
                      });
                    }
                  }}
                  disabled={true || device.template != undefined}
                />
                {/* {!device.template && (
                    <i
                      className="las la-angle-right"
                      onClick={() => {
                        if (channelCount() < 32 && device.template == undefined) {
                          (device as Actor).numberChannelsFromUser = channelCount() + 1;
                          changeChannelNumber(channelCount() + 1);
                        }
                      }}
                    ></i>
                  )} */}
              </div>
            </Field>
          )}

          {!devIsSupply && device.channelType != ChannelType.Lan && (
            //device.channelType != ChannelType.suply230V && device.channelType != ChannelType.suply400V &&
            <TemplateSelection
              device={device}
              layout="table-row" // no itx
              productType={
                device.isSensor
                  ? "Sensor"
                  : device.isDecentralActor
                    ? "DecentralActor"
                    : device.isButton
                      ? "Button"
                      : "Actor"
              }
              context="main" // no itx
            />
          )}
          {/* <ChannelDetectionMode device={device} /> */}

          {!devIsSupply && (
            //device.channelType != ChannelType.suply230V && device.channelType != ChannelType.suply400V && (
            <Field
              label={state.translate("tabGeneralDevice.physicalAddress", "Physikalische Adresse")}
              key="physicalAddress"
            >
              <div
                style={{
                  border: "1px solid var(--border-color)",
                  borderRadius: "var(--input-border-radius)",
                  width: "max-content",
                  paddingLeft: "5px",
                  paddingRight: "5px",
                }}
              >
                <FullPhysicalAddressView
                  device={device}
                  styleText={{
                    fontSize: "1rem",
                    textAlign: "center",
                    minWidth: "10px",
                    outline: "black",
                  }}
                />
              </div>
            </Field>
          )}
        </FieldSet>
        {device.channels.sortBy("tag").filter((channel) => !channel.mappedChannel).length > 0 &&
          device.channels.sortBy("tag").filter((channel) => channel.mappedChannel).length > 0 && // only plausible if min one channel is mapped-> don`t leave empty actor behind
          device.template &&
          device.isActor && (
            <button
              className="button"
              onClick={() => {
                (device as Actor).sortOpenChannelsToCopyOfThisActor();
              }}
            >
              {itx("tabGeneralDevice.shiftChannelsToCopy", "Nicht zugeortnete Kanäle zu kopie des Aktors verschieben")}
            </button>
          )}
        {/* {!device.template && <RequestProductBlock />}   problem, da mit dem link die meldung kommt das die webseite verlassen wird ( vom Browser aus) */}
        {!device.template && <RequestProductBlock2 />}

        {device.template?.knxProductData.productInfo.SupportScenes == "false" && (
          <div style={{ display: "flex", flexDirection: "row", padding: "20px" }}>
            <img src="images/warning.png" style={{ width: "25px", height: "25px", marginRight: "10px" }} />
            {state.translate(
              "tabGeneralDevice.doNotSupportScenes",
              "ESTADA unterstützt keine Szenen für dieses Produkt",
            )}
          </div>
        )}
        {device.template?.knxProductData.hasScript_mapChannelToTag}
        {(device.template?.knxProductData as any)?.currentRules &&
          !(device.template?.knxProductData as any).currentRules.empty && (
            <div style={{ display: "flex", flexDirection: "row", padding: "20px" }}>
              {state.translate(
                "tabGeneralDevice.presetParameter",
                "Dieses Produkt hat von ESTADA voreingestellte Parameter",
              )}
            </div>
          )}

        {frontImage && (
          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              textAlign: "center",
              gap: "6px",
              marginTop: "8px",
            }}
          >
            <img
              className="device-front-image"
              style={{ objectFit: "contain" }}
              src={frontImage}
              alt=""
              width={180}
              height={180}
              draggable={false}
              // onClick={() => openModal(device)}
            />
            {isUiModeProductAdmin() && frontImageSource && (
              <div style={{ fontSize: "11px", opacity: 0.75, whiteSpace: "pre-line" }}>
                {itx("tabGeneralDevice.imageSource", "Image source")}: {frontImageSource}
              </div>
            )}
            {modalOpen && (
              <div className="modal-main">
                <span className="modal-close" onClick={closeModal}>
                  &times;
                </span>
                <img className="modal-img" src={selectedImage} alt={caption} />
                <div className="modal-caption">{caption}</div>
              </div>
            )}
          </div>
        )}
        {device.isButton && device.template && !device.template.isGeneric && (
          <label
            style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "6px", marginTop: "8px" }}
          >
            <input
              type="checkbox"
              data-testid="use-generic-image"
              checked={device.template.useGenericImage}
              onChange={(event) => {
                if (device.template) device.template.useGenericImage = event.target.checked;
              }}
            />
            {itx("tabGeneralDevice.useGenericImage", "Generisches Bild verwenden")}
          </label>
        )}

        {device.template && <SetSameTemplateSettingsButton device={device} />}
        {isUiModeProductAdmin() &&
          device.template &&
          (() => {
            const articleNo = device.template.orderInformation?.articleNo;
            const variants = device.template.knxProductData.productInfo?.Variants;
            const hasShopdata =
              variants ||
              device.template.orderInformation?.imageLink ||
              device.template.orderInformation?.pageLink ||
              device.template.orderInformation?.shopId;
            const noVoltusData = !articleNo || !hasShopdata;
            if (!noVoltusData) return null;
            return (
              <div style={{ fontSize: "11px", opacity: 0.75, marginTop: "4px", textAlign: "center", color: "#c87000" }}>
                {itx("tabGeneralDevice.noVoltusData", "No Voltus data attached (no Variants / orderInformation)")}
              </div>
            );
          })()}
        {isUiModeProductAdmin() && device.template && !device.isDummyDeviceForTemplate && (
          <div style={{ display: "flex", justifyContent: "center" }}>
            {itx(
              "tabGeneralTemplate.savesettingsProduct",
              "To save any Customizing or Setting to the Product-Database,",
            )}
            <br />
            {itx("tabGeneralTemplate.openProduct", "open the Product")}
            <div style={{ display: "flex", alignItems: "flex-end" }} className="iconButton">
              <i
                className="las la-external-link-alt"
                onClick={() => {
                  if (device.template) state.selectionManager.selectedObject = device.template;
                }}
              />
            </div>
          </div>
        )}
      </div>

      <div
        id="middleColumn"
        style={{
          width: "1px",
          border: "0.5px solid var(--border-color)",
          margin: "0px 10px",
        }}
      ></div>

      <div
        key="rightColumn"
        id="rightColumn"
        style={{
          width: "32vw",
          minWidth: "200px",
        }}
      >
        <DeviceProductDetails device={device} />

        {device.template && !device.template.isGeneric && (
          <div
            onClick={onClickProblemButton}
            style={{
              color: "blue",
              cursor: "pointer",
              textAlign: "center",
              textDecoration: "underline",
            }}
          >
            {state.translate("tabGeneralDevice.reportProblem", "report Problem")}
          </div>
        )}
      </div>
    </div>
  );
}

export { TemplateSelection } from "./TemplateSelection";  // no itx
